const chengeBuyLink = () => {
    const buyBtn = document.querySelector('#add-to-basket');
    if (!buyBtn) {
        return false;
    }
    ;
    // const baseLink:string = '/emarket/basket/put/element/';
    // const productId = buyBtn.dataset.product_id
    const basePath = buyBtn.dataset.path;
    const amount = getAmount('#product-amount');
    const props = getProps('[data-element="option_props"]');
    buyBtn.href = `${basePath}?${amount}${props}`;
    console.log(buyBtn);
};
const getAmount = (ampuntFieldSelector) => {
    const amountField = document.querySelector(ampuntFieldSelector);
    let amount = '';
    if (amountField) {
        amount = `amount=${amountField.dataset.amount}&` || '';
    }
    return amount;
};
const getProps = (propsWrapperSelector) => {
    const propsWrapper = document.querySelector(propsWrapperSelector);
    let propsString = '';
    if (!propsWrapper) {
        return propsString;
    }
    const props = propsWrapper.querySelectorAll('input');
    let counter = 1;
    props.forEach(prop => {
        if (prop.checked) {
            if (counter === 1) {
                propsString += `${prop.name}=${prop.value}&`;
            }
            else {
                propsString += `options[opciya_${counter}]=${prop.value}&`;
            }
            counter++;
        }
    });
    return propsString;
};
export default chengeBuyLink;
